module.exports = __webpack_public_path__ + "static/media/unionpay.d73d67e6.svg";